import { canHaveCardLayout } from '../objects/guards';
import Tool, {
  type IToolActionInput,
  type IToolEnabledInput,
  simpleToolButton,
} from './Tool';
import shapeRecordLayoutIcon from '../assets/icons/shapeRecordLayoutIcon.svg';
import { svgToIcon } from '../utils/svg';

class ToolCardLayout extends Tool {
  static toolName = 'Card layout';

  static action({ selection, controller }: IToolActionInput) {
    controller.cardLayoutManager.openCardLayoutEditor(selection);
  }

  static available({ controller, selection }: IToolEnabledInput): boolean {
    return Boolean(
      controller.cardLayoutManager.cardLayoutsReady &&
        selection?.getObjects().every(canHaveCardLayout)
    );
  }

  static buttonComponent() {
    return simpleToolButton(ToolCardLayout, svgToIcon(shapeRecordLayoutIcon));
  }
}

export default ToolCardLayout;
